/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { setLocalStorageWidgetsNotepadSize } from "../LocalStorage/LocalStorageWidgets";
import { ModalFooter, ModalHeader, Modal, Button, Input } from "reactstrap";

// Redux
import { useSelector, useDispatch } from "react-redux";

//Actions
import { resetNotepad } from "../../store/notepad/actions";

//i18n
import { withTranslation } from "react-i18next";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { useHistory } from "react-router";

const Notpad = ({ t, saveNotepad, toggle, isOpen, value = "" }) => {
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const { successNotepad, errorNotepad, loadingNotepad } = useSelector(
    (state) => state.Notepad
  );

  const mainTheme = useSelector((state) => state.Layout.mainTheme);

  const history = useHistory();

  let txtareadimentions = JSON.parse(localStorage.getItem("widgetsControler"));
  let txtarea = document.getElementById("textarea");

  const [width, setWidth] = useState(
    txtareadimentions && txtareadimentions.dim && txtareadimentions.dim.width
  );
  const [height, setheight] = useState(
    txtareadimentions && txtareadimentions.dim && txtareadimentions.dim.height
  );

  const showToast = (type, message) => {
    toastr.options = {
      closeButton: false,
      debug: false,
      newestOnTop: false,
      progressBar: true,
      positionClass: "toast-top-right",
      preventDuplicates: true,
      onclick: null,
      showDuration: "200",
      hideDuration: "200",
      timeOut: "2000",
      extendedTimeOut: "2000",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      onHidden: () => {
        dispatch(resetNotepad());
      },
    };
    toastr[type](message);
  };

  useEffect(() => {
    setLocalStorageWidgetsNotepadSize(width, height);
  }, [width, height]);

  useEffect(() => {
    if (errorNotepad) {
      showToast(
        "error",
        errorNotepad === "Invalid data"
          ? t("Invalid data")
          : errorNotepad[0].value === "Short name in flash messages exists"
          ? t("Flash messages name exists")
          : errorNotepad[0].value === "Flash message not found"
          ? t("Flash message not found")
          : errorNotepad.message
          ? errorNotepad.message
          : errorNotepad === "Your session has expired"
          ? t("Your session has expired")
          : errorNotepad ===
            "Sorry! the page you are looking for could not be found"
          ? t("Sorry! the page you are looking for could not be found")
          : errorNotepad ===
            "Sorry! something went wrong, please contact our support team"
          ? t("Sorry! something went wrong, please contact our support team")
          : errorNotepad[0].value
      );
    }
  }, [errorNotepad, t, dispatch]);

  const dim = () => {
    setWidth(txtarea && txtarea.style.width);
    setheight(txtarea && txtarea.style.height);
  };

  let notepad = document.getElementById("notepadbody");
  let notepadHeader = document.getElementById("notepadheader");
  let modal = document.getElementById("notepadmodal");
  if (isOpen && notepad && notepadHeader && modal) {
    notepadHeader.onmousedown = function (event) {
      let shiftX = event.clientX - notepad.getBoundingClientRect().left;
      let shiftY = event.clientY - notepad.getBoundingClientRect().top;

      notepadHeader.style.cursor = "grab";
      notepad.style.position = "absolute";
      notepad.style.zIndex = 2000;
      document.body.append(notepad);

      moveAt(event.pageX, event.pageY);

      document.getElementsByClassName("modal") &&
        document.getElementsByClassName("modal")[0] &&
        document.getElementsByClassName("modal")[0].classList.add("d-none");

      // moves the notepad at (pageX, pageY) coordinates
      function moveAt(pageX, pageY) {
        notepad.style.left = pageX - shiftX + "px";
        notepad.style.top = pageY - shiftY + "px";
      }

      function onMouseMove(event) {
        moveAt(event.pageX, event.pageY);
      }

      // move the notepad on mousemove
      document.addEventListener("mousemove", onMouseMove);

      // drop the notepad, remove unneeded handlers

      notepadHeader.onmouseup = function () {
        document.removeEventListener("mousemove", onMouseMove);
        notepad.onmouseup = null;
      };
    };

    notepad.ondragstart = function () {
      return false;
    };
  }

  useEffect(() => {
    return history.listen((location) => {
      if (document.getElementById("notepadbody")) {
        document.getElementById("notepadbody").remove();
      }
    });
  }, [history]);

  useEffect(() => {
    document.onkeydown = (e) => {
      if (e.key === "Escape" && isOpen) {
        document.getElementById("notepadbody").remove();
        toggle();
        setWidth(txtarea && txtarea.style.width);
        setheight(txtarea && txtarea.style.height);
      }
    };
  }, [isOpen, txtarea]);

  useEffect(() => {
    if (successNotepad) {
      setTimeout(() => {
        dispatch(resetNotepad());
      }, 3000);
    }
  }, [successNotepad]);

  return (
    <div>
      {" "}
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={false}
        keyboard={true}
        className="modalbody border-0"
        id="notepadmodal"
      >
        <div id="notepadbody" className={`notepadbody ${mainTheme}`}>
          <ModalHeader
            id="notepadheader"
            className="modal-header-no-button border-0 pb-0"
            toggle={toggle}
          >
            {t("Notepad")}
          </ModalHeader>
          <div className="px-3">
            <div
              className="my-2 font-size-12 text-success fade-in-down"
              style={{
                opacity: successNotepad ? "1" : "0",
                transition: "all ease 0.4s",
              }}
            >
              {`(${t("Saved")})`}
            </div>
            <Input
              className="mt-2"
              style={{
                resize: "both",
                minWidth: "225px",
                minHeight: "105px",
                width: width,
                height: height,
              }}
              innerRef={inputRef}
              disabled={loadingNotepad}
              id="textarea"
              type="textarea"
              placeholder={t("Write your notes here")}
              rows={10}
              columns={10}
              defaultValue={value}
              onBlur={() => {
                saveNotepad(inputRef.current?.value);
                setWidth(txtarea && txtarea.style.width);
                setheight(txtarea && txtarea.style.height);
              }}
              onFocus={() => {
                dim();
              }}
            />
          </div>
          <ModalFooter className="flex-nowrap border-0">
            <Button
              type="button"
              color="secondary"
              className="waves-effect btn-dark"
              onClick={() => {
                document.getElementById("notepadbody").remove();
                toggle();
                setWidth(txtarea && txtarea.style.width);
                setheight(txtarea && txtarea.style.height);
              }}
            >
              {t("Close")}
            </Button>
          </ModalFooter>{" "}
        </div>
      </Modal>
    </div>
  );
};

export default withTranslation()(Notpad);
